import { render, staticRenderFns } from "./LibraryContentHeader.vue?vue&type=template&id=39a15c28&scoped=true&"
import script from "./LibraryContentHeader.vue?vue&type=script&lang=js&"
export * from "./LibraryContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./LibraryContentHeader.vue?vue&type=style&index=0&id=39a15c28&prod&lang=scss&scoped=true&"
import style1 from "./LibraryContentHeader.vue?vue&type=style&index=1&id=39a15c28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a15c28",
  null
  
)

export default component.exports